import { AxiosInstance } from 'axios';

export default class PermissionsAPI {
  client: AxiosInstance;

  constructor(client: AxiosInstance) {
    this.client = client;
  }

  async fetchCurrentUserPermissions() {
    return this.client.get('/v2/user/permissions/');
  }

  async fetchUserPermissions({ userId }: { userId: string }) {
    return this.client.get(`/v2/user/${userId}/permissions/`);
  }

  async fetchAllPermissions() {
    return this.client.get('/v2/access-control/permissions/');
  }

  async fetchRolePermissions({ roleId }: { roleId: string }) {
    return this.client.get(`/v2/access-control/role/${roleId}/permissions/`);
  }

  async addRolePermissions({
    roleId,
    data,
  }: {
    roleId: string;
    data: { perm_ids: string[] };
  }) {
    return this.client.post(
      `/v2/access-control/role/${roleId}/permissions/`,
      data,
    );
  }

  async removeRolePermissions({
    roleId,
    data,
  }: {
    roleId: string;
    data: { perm_ids: string[] };
  }) {
    return this.client.delete(
      `/v2/access-control/role/${roleId}/permissions/`,
      {
        data,
      },
    );
  }
}
